<template>
  <div id="payment">
    <SfHeading
      :level="2"
      :title="$t('Payment')"
      class="sf-heading--no-underline"
    />

    <transition mode="out-in" name="sf-fade">
      <div class="payment-methods">
        <div :class="{ 'is-active': paymentMethod==='card'}" class="payment-method__card">

          <SfRadio :selected="paymentMethod" label="" value="card"
                   @change="setPaymentMethod">
            <template #label>
              <span class="label">
                <span class="text">{{$t('card Payment')}}</span>
                <span class="cards">
                  <img alt="Visa" src="/assets/images/cards/Visa-Logo.png"/>
                  <img alt="Mastercard" src="/assets/images/cards/Mastercard-logo.png"/>
                  <img alt="CB" src="/assets/images/cards/logo-cb.jpg"/>
                </span>
              </span>
              <span class="label">
                  <span class="description">{{ $t('pages.checkout.payment.paymentMethods.card.description') }}</span>
              </span>
            </template>
          </SfRadio>
          <div v-if="paymentMethod==='card'">
            <transition>
              <div class="content">
                <div class="address">
                  <SfHeading :level="3" :title="$t('Billing address')"></SfHeading>
                  <div v-if="billingAddress">
                    <div @click="changeBillingAddress">
                      <UserAddress :address="billingAddress"
                                   :show-address-name="false"

                      ></UserAddress>
                    </div>
                    <SfButton class="sf-button--text address-btn color-primary" @click="changeBillingAddress">
                      {{$t('Change billing address')}}
                    </SfButton>
                    <SfButton class="sf-button--text address-btn color-primary" @click="toggleAddressModal">
                      {{$t('add new address')}}
                    </SfButton>
                  </div>
                  <div v-else class="no-address">
                    <p class="error">
                      {{$t('Add a billing address')}}.
                    </p>
                    <SfButton class="sf-button--small" @click="toggleAddressModal"> {{
                        $t('add new address')
                      }}
                    </SfButton>

                  </div>

                </div>
                <div class="payment">
                  <SfHeading :level="3" :title="$t('Card informations')"></SfHeading>
                  <OrkSystemPayPayment ref="OrkAdyenSystemPay" :has-billing="hasBilling" :has-shipping="hasShipping"/>

                  <div class="secure-notice">
                    <SfIcon :view-box="icons.securePayment.viewBox" :icon="icons.securePayment.path"/> Paiement sécurisé
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div :class="{ 'is-active': paymentMethod==='virement'}" class="payment-method__virement">

          <SfRadio :selected="paymentMethod" label="" value="virement"
                   @change="setPaymentMethod">
            <template #label>
              <span class="label"><span class="text">{{$t('Paiement par virement bancaire')}}</span></span>
            </template>
          </SfRadio>
          <div v-if="paymentMethod==='virement'">
            <transition>
              <div class="content">

                <div class="payment">
                  <p class="virement-title"> Pour tout paiement par virement bancaire, veuillez nous contacter au numéro
                    ci-dessous afin d’obtenir un numéro de commande et les instructions de paiement. Votre commande sera
                    préparée et expédiée à réception de votre règlement.</p>
                  <sf-button class="virement-button sf-button color-primary" link="tel:+33146020744"> +33 (01) 46 02 07
                    44
                  </sf-button>

                </div>
              </div>
            </transition>
          </div>
        </div>
        <!--
         <div :class="{
       'is-active': paymentMethod==='paypal'}" class="payment-method__paypal">
           <SfRadio :selected="paymentMethod" label="Paypal" value="paypal" @change="setPaymentMethod">
             <template #label>
               <span class="label"><SfImage alt="Paypal" width="0 height="42px" src="/assets/images/cards/paypal.svg"
               ></SfImage> <span class="text"></span> </span>
             </template>
           </SfRadio>
         </div>

         -->
        <div class="checkout actions">
          <SfButton
            class="sf-button color-white"
            link="/commande/livraison"
            type="button"
          >
            {{$t('Previous step')}}
          </SfButton>


        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {SfButton, SfHeading, SfIcon, SfRadio,} from '@storefront-ui/vue';

import UserAddress from '@/components/UserAddress.vue';

import Api from "@/api/Api";
import icons from "@/utils/icons";
import OrkSystemPayPayment from "@/components/Checkout/SystemPayPayment";


export default {
  name: 'Payment',

  components: {
    UserAddress,
    SfRadio,
    SfHeading,
    SfButton,
    SfIcon,
    OrkSystemPayPayment,

  },
  data() {
    return {
      terms: false,
      paymentReady: false,
      giftCard: null,
      ip: null,
      icons: icons,
      loading: false,
      error: null,
      paymentMethod: 'card',
      state: {isValid: false},
      dropin: null,
      billingAddress: null,
      hasBilling: false,
      hasShipping: false
    };
  },
  computed: {
    customer: {
      get() {
        return this.$store.getters.getProfile;
      },
      set() {

      }
    },
    currentCart: {
      get() {
        return this.$store.getters.getCart;
      },
      set(cart) {
        return cart
      }
    }
  },
  watch: {
    currentCart(newCart) {
      if (newCart) {
        this.getBillingAddress();
        this.getShipment();
      }
    },
    customer(newCustomer) {
      if (!newCustomer) {
        this.router.push('/');
      }
      if (newCustomer.defaultBillingAddress) {
        this.setBillingAddress(newCustomer.defaultBillingAddress)
      }
    },
  },
  mounted() {
    this.getBillingAddress();
    this.getShipment();
  },
  methods: {
    toggleAddressModal() {
      this.$store.dispatch("toggleAddressModal");
    },
    changeBillingAddress() {
      this.$store.dispatch('toggleAddressListModal');
    },
    setBillingAddress(address) {
      this.billingAddress = this.customer.addresses.find(address => address.name === this.customer.defaultBillingAddress) || address;
      Api.cart.setBillingAddress(this.billingAddress.name).then((data) => {
        this.$store.dispatch("setCart", data);
        this.currentCart = data;
        this.hasBilling = true;
      }).catch((e) => {
        let error = null;
        switch (e.status) {
          case 401:
            error = this.$i18n.t("errors.cartAdresse.unauthorized");
            break;
          case 409:
            error = this.$i18n.t("errors.cartAdresse.allReadyExist");
            break;
          case 404:
            error = this.$i18n.t("errors.cartAdresse.notFound");
            break;
          case 500:
            error = this.$i18n.t("errors.server.access");
            break;
        }
        if (error) {
          this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
        }
        this.hasBilling = false;
      });

    },

    getBillingAddress() {
      if (!this.currentCart.billingAddress) {
        if (this.customer.defaultBillingAddress) {
          this.billingAddress = this.customer.defaultBillingAddress
          this.setBillingAddress(this.customer.defaultBillingAddress)
        }
      } else {
        this.billingAddress = this.currentCart.billingAddress
        this.hasBilling = true;
      }
    },

    getShipment() {
      if (!this.currentCart.shipments[0].address || !this.currentCart.shipments[0].shipmentMethod) {
        this.$router.push("/commande/livraison");

      } else {
        this.hasShipping = true
      }
    },

    setPaymentMethod(method) {
      this.paymentMethod = method
    },
  }
}
;
</script>

<style lang="scss" scoped>

.sf-button--text.address-btn {
  font-size: var(--font-size--base);
  font-weight: normal;
  text-decoration: underline !important;
  margin-bottom: var(--spacer-xs);

}

.sf-checkbox__label {
  color: var(--c-text);
}

.virement {
  &-title {
    margin-bottom: 20px;

  }

  &-button {
    margin: auto;
    display: inline-block;
    max-width: 240px;
    min-width: 240px;
  }
}

.coupon {
  display: flex;
  flex-wrap: wrap;
  background: var(--c-primary);
  background-size: cover;
  color: var(--c-white);
  padding: var(--spacer-sm);
  border-radius: 2px;
  align-items: center;
  justify-content: space-between;
  margin: var(--spacer-lg) 0 var(--spacer-base);

  &-label {
    display: block;
    align-items: center;
    font-size: 1.875rem;
    font-weight: 700;
    text-transform: uppercase;
    width: 100%;

    .title {
      display: flex;
      width: 100%;

    }

    .text {

      align-items: center;
      width: 100%;
      display: flex;
      min-height: 42px;
      line-height: 42px;
      margin-left: var(--spacer-xs);
    }

    .desc {
      font-size: var(--font-size--base);
      font-weight: 400;
      text-transform: none;
      margin-left: var(--spacer-xs);
    }
  }

  .content {
    display: flex;

    > * {
      flex: 0 0 1;
    }

    .desc {
      width: 50%;
    }
  }

  &-form {
    flex: 1;
    position: relative;
    padding: 0;
    margin: 0;

    .sf-button {
      position: absolute;
      right: 0;
      top: 0;
      width: 42px;
      height: 42px;
      text-transform: uppercase;
    }
  }

  ::v-deep {

    .sf-input {
      margin-bottom: 0;

      &__wrapper {
        margin: var(--input-margin, 0 0 0 0);
      }

      &__error-message {
        display: none;
      }

    }
  }
}

.payment-method__card {
  .content {
    display: flex;
    flex-wrap: wrap;
    align-self: stretch;
    gap: var(--spacer-base);

    .address, .payment {
      width: 50%;
      flex: 1;
      @include for-mobile {
        width: 100%;
        flex: none;
        flex-wrap: wrap;
      }

      .sf-heading {
        margin-bottom: var(--spacer-base);
      }


    }

    .address {
      margin: 0 0;
      position: relative;

      .user-address {
        margin-right: var(--spacer-base);
        margin-bottom: var(--spacer-sm);
        cursor: pointer;
      }

      &::after {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: block;
        content: '';
        width: 1px;
        background-color: var(--_c-lightgray);
        @include for-mobile {
          position: relative;
          width: 100%;
          height: 1px;
          margin: var(--spacer-base) 0;
        }
      }
    }

    .payment {
      .sf-button {
        @include for-mobile {
          width: 100%;
        }
      }

      .summary__terms {
        margin: var(--spacer-base) 0;

        .sf-link {
          font-size: var(--font-size--base);
        }
      }
    }
  }
}

.user-address {
  cursor: pointer;
  border: 1px solid var(--_c-primary-light);
}

div[class^='payment-method_'] {
  border: 1px solid var(--_c-primary-light);
  border-radius: 2px;
  padding: var(--spacer-base);
  @include for-mobile {
    padding: var(--spacer-sm);
  }
  margin: var(--spacer-base) 0;
  box-shadow: 0 2px 6px -2px rgb(0 0 0 / 10%);

  &:hover, &.is-active {
    box-shadow: 0 2px 6px -2px rgb(0 0 0 / 25%);
  }

  .sf-radio .label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .text {
      font-size: var(--font-size--lg);
      text-transform: uppercase;
      font-weight: var(--font-weight--bold);
    }
    .cards {
      display: flex;
      flex-wrap: wrap;
      gap: var(--spacer-sm);

      img {
        max-height: 2em;
      }
    }
    .description {
      font-size: var(--font-size--sm);
      font-style: italic;
    }
  }
}

.secure-notice {
  display: flex;
  align-items: center;
  color: #53b331;
  justify-content: center;
  gap: 4px;

  ::v-deep {
    svg {
      fill: #53b331;
    }
  }
}

::v-deep {
  .sf-radio__container {
    display: flex;
    align-items: center;
  }
  .sf-radio__content {
    width: 100%;
  }
}

.sf-radio.is-active {
  background: none;
}

.checkout.actions {
  margin: auto 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  @include for-mobile {

  }

  .sf-button {
    width: fit-content;

    white-space: nowrap;
    min-height: 32px;
    padding: var(--spacer-sm) var(--spacer-sm);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      width: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: var(--spacer-sm) 0;
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}
</style>
